import React from "react";
import { Alert, Col, Row } from "antd";
import {
  AndroidFilled,
  AppleFilled,
  DownloadOutlined,
  PlusSquareOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import styles from "./styles.module.css";

/* Public-folder path, so it resolves against the deployed root the same way the
   store badges above it do. */
const APK_URL = "/taskamoon-release.apk";

const StoreOptions = () => (
  <Row gutter={[16, 16]} className="mt-2">
    {}
    <Col xs={24}>
      <div className={styles.storeCard}>
        <div className={styles.storeHead}>
          <AndroidFilled style={{ color: "#3ddc84", fontSize: 22 }} />
          <span>اندروید</span>
        </div>
        <Alert
          type="warning"
          showIcon
          className={styles.androidNote}
          message="نسخه اندروید فقط برای مدیریت پروژه‌ها و کاربران است. بخش پرداخت و مالی را ندارد؛ برای مدیریت مالی از نسخه وب یا PWA استفاده کنید."
        />
        <div className={styles.storeBadges}>
          <a
            href="https://cafebazaar.ir/app/com.solu.taskamoon"
            target="_blank"
            rel="noopener noreferrer"
            className="d-flex align-items-center"
          >
            <img src="/bazaar-badge.png" alt="کافه بازار" />
          </a>
          {/* Same row as the stores, drawn rather than an image: the file is
             served from the app's own origin at a fixed path, so the build that
             is deployed is always the build that downloads. `download` keeps it
             a save instead of the browser trying to render the APK. */}
          <a
            href={APK_URL}
            download
            className={styles.apkBadge}
            aria-label="دانلود مستقیم فایل APK"
          >
            <DownloadOutlined />
            <span className={styles.apkBadgeText}>
              <small>دانلود مستقیم</small>
              <strong>فایل APK</strong>
            </span>
          </a>
        </div>
      </div>
    </Col>

    {}
    <Col xs={24}>
      <div className={styles.storeCard}>
        <div className={styles.storeHead}>
          <AppleFilled style={{ fontSize: 22 }} />
          <span>iOS (وب‌اپ)</span>
        </div>
        <p className={styles.iosDesc}>
          نسخه iOS به‌صورت وب‌اپ (PWA) در دسترس است. برای نصب روی صفحه اصلی:
        </p>
        <ol className={styles.iosSteps}>
          <li>
            این صفحه را در مرورگر <b>Safari</b> باز کنید.
          </li>
          <li>
            روی دکمه <ShareAltOutlined /> <b>اشتراک‌گذاری (Share)</b> بزنید.
          </li>
          <li>
            گزینه <PlusSquareOutlined />{" "}
            <b>«افزودن به صفحه اصلی» (Add to Home Screen)</b> را انتخاب کنید.
          </li>
        </ol>
      </div>
    </Col>
  </Row>
);

export default StoreOptions;
